import React from 'react';

import {AppButton} from '@/components/Button';
import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import PopupSticked from '@/components/Popup/PopupSticked';
import {twx} from '@/utils/tailwindUtils';

const InfoPopup = ({
    onClose,
    title,
    description,
    primaryButton,
    secondaryButton,
    className,
    icon,
    overlayClassName,
    isBlockerOverlay,
    shouldCloseOnOverlayClick,
}) => {
    return (
        <PopupSticked
            className={twx('flex flex-col items-center pt-18 ml:px-8', className)}
            isCloseVisible
            onClose={onClose}
            aria-label={title}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
            isBlockerOverlay={isBlockerOverlay}
            overlayClassName={overlayClassName}
            closeButtonClass='right-4 top-6'
        >
            <RemoteIconV2 icon={icon} className='h-12 w-12' />
            <h2 className='mb-4 mt-2 text-32 ml:mt-4 ml:text-28'>{title}</h2>
            <p>{description}</p>

            <div className='mt-8 flex w-full flex-col gap-3'>
                {primaryButton && (
                    <AppButton
                        className='mt-0'
                        primary
                        light
                        aria-label={primaryButton.ariaLabel}
                        onClick={primaryButton.onClick}
                    >
                        {primaryButton.text}
                    </AppButton>
                )}
                {secondaryButton && (
                    <AppButton
                        className='mt-0'
                        secondary
                        light
                        aria-label={secondaryButton.ariaLabel}
                        onClick={secondaryButton.onClick}
                    >
                        {secondaryButton.text}
                    </AppButton>
                )}
            </div>
        </PopupSticked>
    );
};

export default InfoPopup;
